import {
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { IDatableColumn } from '../column.interface';
import { IDatatableProps } from '../datatable-props.interface';
import { blackGradient } from './style/styleConstants';

const useStyles = makeStyles({
  tableHeaderCell: {
    fontWeight: 'bold',
    fontSize: '2rem',
    height: '4rem',
    borderBottom: '2px solid black',
    background: blackGradient,
    color: 'white',
  },
  tableBody: {
    background: 'grey',
    color: 'white',
  },
  tableDataCellEven: {
    fontSize: '1rem',
    background: '#FFFFFF',
  },
  tableDataCellOdd: {
    fontSize: '1rem',
    background: '#FFFAFA',
  },
});

export default function OldStyleLeaderboardTable(
  props: IDatatableProps,
): JSX.Element {
  const data = props.data;

  const columns = props.columns;
  const classes = useStyles();

  const showIndex = 'showIndex' in props ? props.showIndex : false;
  const headerCellStyle = props.headerCellStyle || classes.tableHeaderCell;

  function extractValue(value: any, keystring: string) {
    const keys = keystring.split('.');
    for (const key of keys) {
      value = value[key];
      if (!value) {
        break;
      }
    }
    return value;
  }

  return (
    <Card>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {showIndex && (
                <TableCell align="center" className={headerCellStyle} key="#">
                  #
                </TableCell>
              )}

              {columns.map((column: IDatableColumn) => (
                <TableCell
                  align="center"
                  className={headerCellStyle}
                  key={column.key}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row: any, index: number) => (
              <TableRow key={index}>
                {showIndex && (
                  <TableCell
                    align="center"
                    className={`${
                      index % 2 === 0
                        ? classes.tableDataCellEven
                        : classes.tableDataCellOdd
                    }`}
                    key={index}
                  >
                    {index + 1}
                  </TableCell>
                )}
                {columns.map((column: IDatableColumn, i: number) => (
                  <TableCell
                    align="center"
                    className={`${
                      index % 2 === 0
                        ? classes.tableDataCellEven
                        : classes.tableDataCellOdd
                    }`}
                    key={i}
                  >
                    {column.key && column.keyType === 'deepkey'
                      ? extractValue(row, column.key)
                      : row[column.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
